import React, { useState } from 'react';
import { Form, SonForm, StatusMessages, useForm } from '../../../../_lib/Form2';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ButtonIconActionConfirm, ButtonIconActionDecline } from '../../Btn/ButtonWrapper';
import Event from '../../../../lib/EventEmitter';
import { useRefreshBlock } from '../../../../_lib/BlockFetcher';
import { Form2Modifier } from '../../../../_lib/Form2/Form';

type RequestManagementType = {
  approveForm: SonForm<any>;
  rejectForm: SonForm<any>;
};

/**
 * Renders the Buttons to accept or reject Member Requests
 */
export function RequestManagement({ approveForm, rejectForm }: RequestManagementType) {
  const { t } = useSonTranslation('MemberRow');
  const { delayedRefresh } = useRefreshBlock();
  const [messageSuccess, setMessageSuccess] = useState(t('status.approveRequest.success'));
  const [messageFail, setMessageFail] = useState(t('status.approveRequest.fail'));

  const { formProps, fetchState } = useForm({
    form: {
      method: 'POST',
      params: [],
      url: '',
    },
    onError: (reason: any) => {
      if (reason?.request.responseURL.includes('RejectRequest')) {
        setMessageFail(t('status.rejectRequest.fail'));
      }
    },
    onSuccess: response => {
      Event.emit('refetch-data', 'RequestManagement');

      if (response?.request.responseURL.includes('RejectRequest')) {
        setMessageSuccess(t('status.rejectRequest.success'));
      }
      delayedRefresh();
    },
  });

  return (
    <Form {...formProps} modifier={Form2Modifier.NO_PADDING}>
      <div className="accept-decline-form">
        <Heading hierarchy={3} className="accept-decline-form__headline font-regular-15-23">
          {t('actions.acceptRequest.headline')}
        </Heading>
        <div className="accept-decline-form__buttons">
          <ButtonIconActionConfirm
            text={t('actions.acceptRequest.approve')}
            type="submit"
            formAction={approveForm.url}
          />
          <ButtonIconActionDecline text={t('actions.acceptRequest.reject')} type="submit" formAction={rejectForm.url} />
        </div>
      </div>
      <StatusMessages
        messageSuccess={messageSuccess}
        messageSending={t('status.sending')}
        messageFail={messageFail}
        fetchState={fetchState}
      />
    </Form>
  );
}
